module.exports = __webpack_public_path__ + "img/opa_md.f4c11efa.png";